<h5 class="mt-3 mx-3 mb-1" translationEditableDirective="LICENSES">
  {{ 'RDNS' | translate }}
</h5>
<div class="pb-4 mx-3">
  <radio
    [options]="radioOptions"
    [controlled]="true"
    name="dataCycle"
    [value]="dataCycle"
    (onChange)="dataCycleChange($event)"
  ></radio>
</div>
<app-table
  [isLoading]="isLoading"
  [totalItems]="documents.size"
  [rows]="documents"
  [columns]="columns"
>
  <ng-template let-row="row" #generatedOn>
    {{ row.get('generatedOn') || '' | formatDate }}
  </ng-template>
  <ng-template let-row="row" #actionDownload>
    <div class="buttons" style="justify-content: end">
      <button
        class="button is-success is-small p-0 has-text-white"
        (click)="download(row)"
        style="width: 25px"
        *ngIf="row.get('generatedOn')"
      >
        <svg
          width="18px"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z" />
        </svg>
      </button>
      <button
        class="button is-warning is-small has-text-white p-0"
        (click)="generate(row)"
        translationEditableDirective="GENERATE"
        *ngIf="!row.get('generatedOn')"
        [disabled]="isGenerating"
        style="width: 25px"
      >
        <svg
          width="18px"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
        >
          <path
            d="M17,14H19V17H22V19H19V22H17V19H14V17H17V14M12,17V15H7V17H12M17,11H7V13H14.69C13.07,14.07 12,15.91 12,18C12,19.09 12.29,20.12 12.8,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19A2,2 0 0,1 21,5V12.8C20.12,12.29 19.09,12 18,12L17,12.08V11M17,9V7H7V9H17Z"
          />
        </svg>
      </button>
      <ng-container *ngxPermissionsOnly="['PDF_ACTION_DELETE_CURRENT']">
        <button
          *ngIf="
            row.getIn(['dataCycle', 'id']) == currentDataCycleId &&
            row.get('generatedOn')
          "
          class="button is-danger is-small has-text-white p-0"
          style="width: 24px"
          (click)="delete(row)"
          [disabled]="isDeleting"
        >
          <svg
            width="18px"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path
              d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z"
            />
          </svg>
        </button>
      </ng-container>
    </div>
  </ng-template>
</app-table>
